module.exports = __webpack_public_path__ + "img/point3_screen_slide1.3f6a503e.jpg";